import PageLayout from "../../layouts/PageLayout";
import SecaoPagina from "../../components/SecaoPagina";
import FormPesquisa from "../../components/FormPesquisa";

const dataMock = [
	{
		"ID_PESQUISA": 0,
		"TIPO_PESQUISA": "POS_VENDA",
		"TEXTO": "Pesquisa de id número 0.",
		"TIPO_NOTA": "NOTA",
		"AVALIACAO_MIN": 0,
		"AVALIACAO_MAX": 1,
		"MOTIVO_NOTA": "1"
	},
	{
		"ID_PESQUISA": 4,
		"TIPO_PESQUISA": "POS_VENDA",
		"TEXTO": "Pesquisa de id número 4.",
		"TIPO_NOTA": "MÚLTIPLA ESCOLHA",
		"AVALIACAO_MIN": 0,
		"AVALIACAO_MAX": 2,
		"MOTIVO_NOTA": "0"
	},
	{
		"ID_PESQUISA": 9,
		"TIPO_PESQUISA": "POS_VENDA",
		"TEXTO": "Pesquisa de id número 9.",
		"TIPO_NOTA": "TEXTO LIVRE",
		"AVALIACAO_MIN": 0,
		"AVALIACAO_MAX": 3,
		"MOTIVO_NOTA": "1"
	},
	{
		"ID_PESQUISA": 13,
		"TIPO_PESQUISA": "POS_VENDA",
		"TEXTO": "Pesquisa de id número 13.",
		"TIPO_NOTA": "NOTA",
		"AVALIACAO_MIN": 0,
		"AVALIACAO_MAX": 4,
		"MOTIVO_NOTA": "0"
	},
	{
		"ID_PESQUISA": 40,
		"TIPO_PESQUISA": "POS_VENDA",
		"TEXTO": "Pesquisa de id número 40.",
		"TIPO_NOTA": "MÚLTIPLA ESCOLHA",
		"AVALIACAO_MIN": 0,
		"AVALIACAO_MAX": 5,
		"MOTIVO_NOTA": "1"
	},
	{
		"ID_PESQUISA": 45,
		"TIPO_PESQUISA": "POS_VENDA",
		"TEXTO": "Pesquisa de id número 45.",
		"TIPO_NOTA": "TEXTO LIVRE",
		"AVALIACAO_MIN": 0,
		"AVALIACAO_MAX": 6,
		"MOTIVO_NOTA": "0"
	}
];

const tipoMock = 0;

export default function Pesquisa({ data, tipo }) {
	return (
		<PageLayout>
			<SecaoPagina
				$paddingmin={"2em 2em 9em"}
				$paddingmid={"2em 2em 9em"}
				$paddingmax={"2em 4em 8em"}
				id={"formPesquisa"}
			>
				<FormPesquisa
					pesquisas={JSON.stringify(dataMock)}
					titulo={tipoMock}
					color={"black"}
				/>
			</SecaoPagina>
		</PageLayout>
	);
}
